import { SettingsStatusTone } from '../../../constants/settings'

export const SETTINGS_STATUS_TONE_COLORS = {
  [SettingsStatusTone.Fail]: {
    backgroundColor: 'var(--color-error-10)',
    textColor: 'var(--color-error)',
  },
  [SettingsStatusTone.InProgress]: {
    backgroundColor: 'var(--color-in-progress-10)',
    textColor: 'var(--color-in-progress)',
  },
  [SettingsStatusTone.Neutral]: {
    backgroundColor: 'var(--secondary-text-color-10)',
    textColor: 'var(--secondary-text-color)',
  },
  [SettingsStatusTone.Ok]: {
    backgroundColor: 'var(--color-success-10)',
    textColor: 'var(--color-success)',
  },
}
